import { useTransformImage } from "@/hooks/bulkResizer/useTransformImage";
import { rotateSetRotation, setPreview } from "@/store/features/bulkResize/actions";
import { getRotationOperation } from "@/store/features/bulkResize/utils/operations/getRotationOperation";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { AnalyticsHelper } from "@/utils/adsense/AnalyticsHelper";
import { sleep } from "@/utils/sleep";
import { useBulkResizerImageProvider } from "../../BulkResizerImageProvider";

export const useBulkResizerRotateSettings = (imageId: string) => {
    const image = useAppSelector((store) => store.bulkResize.images.find((image) => image.id === imageId));
    if (!image) throw new Error("image not found ");
    const {
        rotate: { rotation, straighten },
    } = image;
    const dispatch = useAppDispatch();
    const { transformImage } = useTransformImage();
    const { operation, setOperation } = useBulkResizerImageProvider();
    const rotatingState =
        operation === "rotate-cw" ? "clock-wise" : operation === "rotate-ccw" ? "reverse-clock-wise" : "";

    const handleStraightenChange = (_value: number) => {};

    const handleDirection = async (direction: "clock-wise" | "reverse-clock-wise") => {
        if (operation) return;
        setOperation(direction === "clock-wise" ? "rotate-cw" : "rotate-ccw");

        await sleep();
        AnalyticsHelper.collectData({
            pageKey: "bulk-resize-editor",
            event: "Rotate",
            featureName: "Bulk Image Resizer",
            eventLabel: "Editor Page",
        });
        const weight = direction === "clock-wise" ? 1 : -1;
        const value = (rotation + 90 * weight) % 360;
        const newOperation = getRotationOperation(image, value);
        const src = await transformImage(imageId, newOperation);

        dispatch(setPreview({ id: imageId, value: { src } }));
        setOperation(null);
        dispatch(rotateSetRotation({ imageId, value }));
    };

    return {
        rotation,
        straighten,
        handleStraightenChange,
        handleDirection,
        rotatingState,
    };
};
